





























































































































































































































import VueI18n from "@/i18n";
import { Component, Vue, Watch } from "vue-property-decorator";
import DxPieChart, {
  DxSize,
  DxSeries,
  DxLabel,
  DxConnector,
  DxExport,
} from "devextreme-vue/pie-chart";
import { apiService, Interfaces, AppConstants } from "@/core/Export";
import store from "@/store";
import SupportIcon from "@/components/Support/SupportIcon.vue";

@Component({
  components: { DxPieChart, DxSize, DxSeries, DxLabel, DxConnector, DxExport, SupportIcon },
})
export default class EmployeesListPage extends Vue {
  empColumns: Array<any>;
  searchText: string;
  currentFilter: string;
  hourTypesPieDataSource: Array<any>;
  attendCapacityPieDataSource: Array<any>;

  constructor() {
    super();
    this.currentFilter = "all";
    this.searchText = null;
    this.empColumns = new Array<any>();
    this.hourTypesPieDataSource = new Array<any>();
    this.attendCapacityPieDataSource = new Array<any>();
  }

  created() {
    this.appEnv.screenTitle = this.$t("pages.employeeList.title");
    this.onSetEmployeesListColumns();
    this.onSetEmployeeId(this.currentActingEmployeeId, true);
    this.onGetManagerMonthStatistics();
  }

  mounted() {
    this.fixTableScrollingIssue();
  }

  fixTableScrollingIssue() {
    var isIOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
    if (isIOSDevice && this.appEnv.isRtl) {
      let q_table_middle = document.getElementsByClassName(
        "q-table__middle"
      )[0] as HTMLElement;
      if (q_table_middle) {
        q_table_middle.style.direction = "ltr";
        let table = q_table_middle.firstElementChild as HTMLElement;
        table.style.direction = "rtl";
      }
    }
  }

  onActingManagerChanged(e) {
    if (this.actingManagerId) {
      this.currentActingEmployeeId = this.actingManagerId;
    } else {
      this.actingManagerId = null;
      this.currentActingEmployeeId = 0;
    }
    this.previousEmployeeIds = [];
    this.onGetManagerEmployees();
    //this.onSetEmployeeId(this.actingManagerId);
  }

  onSetEmployeeId(id, isFirstTime = false) {
    if (!isFirstTime) {
      this.previousEmployeeIds.push(this.currentActingEmployeeId);
    }
    this.currentActingEmployeeId = id;
    this.onGetManagerEmployees();
  }

  onSetBackEmployeeId() {
    if (this.previousEmployeeIds.length > 0) {
      // if (this.previousEmployeeIds.length == 1 && this.actingManagerId) {
      //   this.actingManagerId = null;
      // }
      this.currentActingEmployeeId = this.previousEmployeeIds.pop();
      this.onGetManagerEmployees();
    }
  }

  @Watch("employeeAdditionalJobKey")
  onGetManagerEmployees() {
    this.appEnv.isBusy = true;
    apiService
      .getManagerEmployees(
        this.selectedYear,
        this.selectedMonth,
        this.currentActingEmployeeId
      )
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.employeesList = call.callResult.data;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  @Watch("employeeAdditionalJobKey")
  onGetManagerMonthStatistics() {
    this.appEnv.isBusy = true;
    apiService
      .getManagerMonthStatistics(
        this.appEnv.UserInfo.employeeId,
        this.selectedYear,
        this.selectedMonth
      )
      .then((res) => {
        let result = res as Interfaces.iServiceRequest;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.hourTypesPieDataSource = call.callResult.data["hourTypes"];
          this.attendCapacityPieDataSource = call.callResult.data["attendCapacity"];
          this.onMapAttendCapacityPieDataSource();
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch((err) => {
        this.appEnv.isBusy = false;
      });
  }

  onMapAttendCapacityPieDataSource() {
    let attendHours = this.attendCapacityPieDataSource.find(
      (s) => s.key == "attendHours"
    );

    let stdHours = this.attendCapacityPieDataSource.find((s) => s.key == "StdHours");

    if (attendHours && stdHours) {
      attendHours.key = this.$t("pages.employeeList." + attendHours.key);
      stdHours.key = this.$t("pages.employeeAttendDetails.missingHours");
      stdHours.amount = (stdHours.amount - attendHours.amount) as number;
      stdHours.percent = (stdHours.percent - attendHours.percent) as number;
    }
  }

  onOpenEmployeeDetails(employee: any) {
    if (employee) {
      this.currentEmployee = employee;
      this.$router.push({
        name: AppConstants.Routes.M_Employee_Details,
      });
    }
  }

  formatPieLabel(pointInfo) {
    return `${pointInfo.value.toFixed(2)} (${pointInfo.percentText})`;
  }

  @Watch("currentSelectedEmployees")
  onEmployeesSelctionChanges() {
    this.currentSelectedEmployees;
  }

  @Watch("selectedYear")
  @Watch("selectedMonth")
  onYearOrMonthChanged() {
    this.onGetManagerEmployees();
    this.onGetManagerMonthStatistics();
  }

  onSetEmployeesListColumns() {
    this.empColumns.push({
      name: "attendToday",
      field: "attendToday",
      format: (val, row) => {
        let dotClass = '';
        let tooltipTranslation = '';

        if (row.isAttendNow) {
          tooltipTranslation = 'employeesList.legend_present_now'
          dotClass = 'rb-emp-present-now'
        }
        else if (row.attendToday) {
          tooltipTranslation = 'employeesList.legend_present_today'
          dotClass = 'rb-emp-present-today'
        }
        else if (row.hasSickToday) {
          tooltipTranslation = 'employeesList.legend_sick'
          dotClass = 'rb-emp-sick'
        }
        else if (row.hasVacationToday) {
          tooltipTranslation = 'employeesList.legend_vacation'
          dotClass = 'rb-emp-vacation'
        }
        else {
          tooltipTranslation = 'employeesList.legend_not_present';
          dotClass = 'bg-white';
        }

        row.attendTodayTooltip = tooltipTranslation;

        return dotClass;
      },
      label: "",
      align: "center",
      sortable: true,
      supportText: 'supportText.attendTodaySupport',
      isSetMarginLeft: false,
    });
    this.empColumns.push({
      name: "displayName",
      field: "displayName",
      label: this.$t("fields.displayName"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "firstEntryTimeText",
      field: "firstEntryTimeText",
      label: this.$t("pages.employeeAttendDetails.entry"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "lastExitTimeText",
      field: "lastExitTimeText",
      label: this.$t("pages.employeeAttendDetails.exit"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "salaryNo",
      field: "salaryNo",
      label: this.$t("fields.salaryNo"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "orgStructName",
      field: "orgStructName",
      label: this.$t("fields.orgStructId"),
      align: "left",
      sortable: true,
    });

    this.empColumns.push({
      name: "empEmploymentTypeCode",
      field: "empEmploymentTypeCode",
      label: this.$t("fields.empEmploymentTypeCode"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "jobTypeName",
      field: "jobTypeName",
      label: this.$t("fields.jobTypeName"),
      align: "left",
      sortable: true,
    });
    if (this.isIndirectManagerActiveInPortal) {
      this.empColumns.push({
        name: "isManager",
        field: "isManager",
        label: this.$t("manager"),
        align: "left",
        sortable: false,
      });
    }
    this.empColumns.push({
      name: "phoneNo",
      field: "phoneNo",
      label: this.$t("fields.phoneNo"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "noOfLogsToApprove",
      field: "noOfLogsToApprove",
      label: this.$t("fields.noOfLogsToApprove"),
      align: "left",
      sortable: true,
      supportText: 'supportText.noOfLogsToApproveSupport',
      isSetMarginLeft: true,
    });
    this.empColumns.push({
      name: "noOfAMRErrors",
      field: "noOfAMRErrors",
      label: this.$t("fields.noOfAMRErrors"),
      align: "left",
      sortable: true,
      supportText: 'supportText.noOfAMRErrorsSupport',
      isSetMarginLeft: true,
    });
    this.empColumns.push({
      name: "empApprovalDate",
      field: "empApprovalDate",
      label: this.$t("pages.employeeAttendDetails.empSign"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "empSecretaryApprovalDate",
      field: "empSecretaryApprovalDate",
      label: this.$t("pages.employeeAttendDetails.secretarySign"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "empManagerApprovalDate",
      field: "empManagerApprovalDate",
      label: this.$t("pages.employeeAttendDetails.managerSign"),
      align: "left",
      sortable: true,
    });
    this.empColumns.push({
      name: "empAdditionalApprovalDate",
      field: "empAdditionalApprovalDate",
      label: this.$t("pages.employeeAttendDetails.additionalSign"),
      align: "left",
      sortable: true,
    });
  }

  onShowApprovalDateNotify(approvalDate: string, isManager: boolean) {
    if (!approvalDate) return;
    if (this.appEnv.IsMobileApp || this.$q.screen.xs) {
      this.$q.notify({
        message: `${isManager ? this.$t("approvlas.manager_sign") : this.$t("approvlas.emp_sign")
          } - ${approvalDate}`,
        timeout: 4000,
        textColor: "white",
        color: "primary",
        actions: [
          { label: this.$t("close").toString(), color: "white", handler: () => { } },
        ],
      });
    }
  }

  get employeeAdditionalJobKey() {
    return store.getters.employeeAdditionalJobKey;
  }

  get isIndirectManagerActiveInPortal() {
    return this.appEnv.isAllowed(
      AppConstants.Permissions.IsIndirectManagerActiveInPortal
    );
  }

  get isSetBackEmployeeIdButtonVisible() {
    return this.previousEmployeeIds.length > 0;
  }

  set currentActingEmployeeId(v) {
    store.commit(AppConstants.StoreMutations.UpdateCurrentActingEmployeeId, v);
  }

  get currentActingEmployeeId() {
    return store.getters.currentActingEmployeeId;
  }

  set actingManagerId(v) {
    store.commit(AppConstants.StoreMutations.UpdateActingManagerId, v);
  }

  get actingManagerId() {
    return store.getters.actingManagerId;
  }

  set previousEmployeeIds(v) {
    store.commit(AppConstants.StoreMutations.updatePreviousEmployeeIds, v);
  }

  get previousEmployeeIds() {
    return store.getters.previousEmployeeIds;
  }

  get actingManagers() {
    return store.getters.actingManagers;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  set currentEmployee(value) {
    store.commit(AppConstants.StoreMutations.UpdateCurrentEmployee, value);
  }

  get currentSelectedEmployees() {
    return store.state.currentSelectedEmployees;
  }

  get selectedRowsMessage() {
    return this.currentSelectedEmployees.length + ` ${VueI18n.t(this.currentSelectedEmployees.length === 1 ? 'row' : 'rows')} ${VueI18n.t('rowsSelected')}.`;
  }

  get recordsPerPageOptions() {
    return [
      {
        label: '10',
        value: 10
      },
      {
        label: '15',
        value: 15
      },
      {
        label: '20',
        value: 20
      },
      {
        label: '25',
        value: 25
      },
      {
        label: '50',
        value: 50
      },
      {
        label: 'All',
        value: 0
      }];
  }

  set currentSelectedEmployees(value) {
    store.commit(AppConstants.StoreMutations.UpdateCurrentSelectedEmployees, value);
  }

  get filterdEmployeesList() {
    switch (this.currentFilter) {
      case "all":
        return this.employeesList;
        break;
      case "watingForApproval":
        return this.employeesList.filter((s) => s.noOfLogsToApprove > 0);
        break;
      case "toHande":
        return this.employeesList.filter(
          (s) => s.noOfLogsToApprove + s.noOfAMRErrors > 0
        );
        break;
      default:
        break;
    }
  }

  get employeesList() {
    return store.getters.employeesList;
  }

  set employeesList(value) {
    store.commit(AppConstants.StoreMutations.UpdateEmployeesList, value);
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
